module.exports = __webpack_public_path__ + "media/packs/images/transit/transit-f4b98ac7e11aeb3775a54baf869b3286.svg";